import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUserDetails, updateUserProfile } from '../actions/userActions';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import FormContainer from './FormContainer';
import { useNavigate, useParams } from 'react-router-dom';

const Profile = () => {
  const { id } = useParams();
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [subscribedToNewsletter, setSubscribedToNewsletter] = useState(false);
  const [has_active_subscription, set_has_active_subscription] = useState('');

  const dispatch = useDispatch();

  const userDetails = useSelector(state => state.userDetails) || {};
  const { error, loading, user } = userDetails;

  const userLogin = useSelector(state => state.userLogin) || {};
  const { userInfo } = userLogin;

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password === confirmPassword) {
      const userUpdates = {
        id: userInfo._id, // or use 'id' from useParams
        name: userInfo.name,
        email: email,
        username: username,
        password: password,
        subscribedToNewsletter: subscribedToNewsletter
      };
      await dispatch(updateUserProfile(userUpdates));
    } else {
      console.log('Passwords do not match');
    }
  };

  useEffect(() => {
    if (!userInfo) {
      navigate('/login');
    } else {
      if (!user || !user.username) {
        dispatch(getUserDetails(id));
      } else {
        setUsername(user.username);
        setEmail(user.email);
        setSubscribedToNewsletter(user.subscribed_to_newsletter);
        set_has_active_subscription(user.has_active_subscription)
      }
    }
  }, [dispatch, navigate, userInfo, user, id]);

  return (
    <Row>
      <Col md={3}>
        <h2>User Profile</h2>
        <FormContainer>
          <Form onSubmit={handleSubmit}>           
            <Form.Group controlId='username'>
              <Form.Label>Username</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </Form.Group>

            <Form.Group controlId='email'>
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Form.Group>

            <Form.Group controlId='subscribeNewsletter'>
              <Form.Check
                type='checkbox'
                label='Subscribe to Newsletter'
                checked={subscribedToNewsletter}
                onChange={(e) => setSubscribedToNewsletter(e.target.checked)}
              />
            </Form.Group>
            

            <Form.Group controlId='password'>
              <Form.Label>New Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Enter new password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Form.Group>

            <Form.Group controlId='confirmPassword'>
              <Form.Label>Confirm New Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Confirm new password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </Form.Group>

      <Form.Group controlId='subscription'>
              <Form.Check
                type='checkbox'
                label='Subscribed?'
                checked={has_active_subscription}
                onChange={(e) => set_has_active_subscription(e.target.checked)}
              />
            </Form.Group>
            <Button type='submit' variant='primary'>Update</Button>
          </Form> 
          <br/>
          <br/>
          <br/>
        </FormContainer>
      </Col>

    </Row>
   
  );
};

export default Profile;
